import React, { useState } from 'react';

/**
 * LazyImage — afișează un spinner până când imaginea se încarcă complet.
 * Acceptă toate props-urile unui <img> standard.
 */
export default function LazyImage({ src, alt, className = '', spinnerClassName = '', ...props }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  return (
    <div className="relative w-full h-full">
      {/* Spinner — vizibil cât timp imaginea nu s-a încărcat */}
      {!loaded && !error && (
        <div className={`absolute inset-0 flex items-center justify-center bg-[#F0EDE8] dark:bg-[#2E2C2A] ${spinnerClassName}`}>
          <svg
            className="animate-spin h-7 w-7 text-[#A67B5B]"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12" cy="12" r="10"
              stroke="currentColor" strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            />
          </svg>
        </div>
      )}

      {/* Fallback dacă poza nu se încarcă */}
      {error && (
        <div className="absolute inset-0 flex items-center justify-center bg-[#F0EDE8] dark:bg-[#2E2C2A] text-[#A67B5B]/50 text-xs">
          Imagine indisponibilă
        </div>
      )}

      <img
        src={src}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        onError={() => { setError(true); setLoaded(true); }}
        className={`${className} transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
        {...props}
      />
    </div>
  );
}

